import { useState, useEffect } from 'react';
import { authFetch } from '../auth';

const HEARTBEAT_MS = 30_000;
const URL = '/api/cms/presence';

/**
 * 현재 어드민 페이지를 같이 열고 있는 다른 사용자 이름 목록을 반환.
 * page가 null이면 추적하지 않는다.
 */
export function usePresence(page) {
  const [others, setOthers] = useState([]);

  useEffect(() => {
    if (!page) return;

    const beat = () => authFetch(`${URL}?page=${encodeURIComponent(page)}`, { method: 'POST' }).catch(() => {});
    const poll = () =>
      authFetch(`${URL}?page=${encodeURIComponent(page)}`)
        .then((r) => (r.ok ? r.json() : []))
        .then(setOthers)
        .catch(() => {});

    beat().then(poll);
    const id = setInterval(() => { beat().then(poll); }, HEARTBEAT_MS);

    return () => {
      clearInterval(id);
      setOthers([]);
      authFetch(`${URL}?page=${encodeURIComponent(page)}`, { method: 'DELETE' }).catch(() => {});
    };
  }, [page]);

  return others;
}
